export default {
  namespaced: true,
  employees: {
    title: 'Funcionários | Funcionário',
    first_name: 'nome',
    last_name: 'sobrenome',
    employee_id: 'ID do funcionário',
  }
}
